module.exports = __webpack_public_path__ + "img/document-favorite.763a9cde.svg";